<div class="alert m-0 p-2 w-100" [ngClass]="_style() ? _style() : 'alert-danger'">
  <div class="d-flex align-items-center">
    <div class="flex-grow-0 me-2">
      <i class="bi bi-exclamation-circle-fill text-danger" [ngClass]="{ 'fs-4': !_useSmallIcon() }"></i>
    </div>
    <div class="flex-grow-0 text-break-line">
      <div class="row">
        <div class="col-12">{{ _message() }}</div>
      </div>
    </div>
  </div>
</div>
